import { createAsyncThunk } from "@reduxjs/toolkit";

import { ApiService } from "../../service/ApiService";

// // -- temporary  ----
// const locales = [
//   {
//     id: "1",
//     code: "en",
//     name: "English",
//     originalName: "English",
//   },
//   {
//     id: "2",
//     code: "ru",
//     name: "Russian",
//     originalName: "Русский",
//   },
//   {
//     id: "3",
//     code: "uk",
//     name: "Ukrainian",
//     originalName: "Українська",
//   },
// ];
// -- temporary  ----

export const getLanguages = createAsyncThunk(
  "languages/getLanguages",
  async (_, { rejectWithValue }) => {
    try {
      // temporary
      // return locales;
      return ApiService.getActiveLanguages();
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);
